import type { LucideIcon } from 'lucide-react';
import { AppWindow, Bell, Hexagon, Home, List, Percent, Settings, ShieldAlert, Store, User, Wallet } from 'lucide-react';
import { GROUP, PAGE } from '@kioskgaming/ui';

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  matchPrefix?: string;
  primary?: boolean;
  /** Shorter label for the phone bottom bar only (its slots are ~87px at 375px); the sidebar keeps `label`. */
  mobileLabel?: string;
};

export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: PAGE.dashboard, icon: Home, end: true, primary: true },
  { to: '/shops', label: PAGE.shops, icon: Store, matchPrefix: '/shops', primary: true },
  // matchPrefix keeps Players highlighted on a Player's detail page (/players/:id).
  { to: '/players', label: PAGE.players, icon: User, matchPrefix: '/players', primary: true },
  { to: '/transactions', label: PAGE.creditTransactions, mobileLabel: GROUP.transactions, icon: List, end: true, primary: true },
  { to: '/cash-transactions', label: PAGE.cashTransactions, icon: Hexagon, matchPrefix: '/cash-transactions', primary: false },
  { to: '/online-transactions', label: PAGE.usdWalletTransactions, icon: Wallet, end: true, primary: false },
  { to: '/provider-fees', label: PAGE.feeConfiguration, icon: Percent, end: true, primary: false },
  { to: '/fraud-indicators', label: PAGE.fraudIndicators, icon: ShieldAlert, end: true, primary: false },
  { to: '/popups/send', label: PAGE.popups, icon: AppWindow, end: true },
  { to: '/broadcasts/send', label: PAGE.broadcasts, icon: Bell, end: true },
  { to: '/settings', label: PAGE.settings, icon: Settings, end: true },
];
